<div id="smart-classrooms" class="inner-page py-5">
  <div class="container-fluid px-lg-5">
    <h2 class="title text-uppercase mb-2">Smart Classrooms</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College integrates digital learning into the daily curriculum through advanced smart classrooms, transforming traditional teaching into a dynamic, interactive experience.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Interactive Learning</h4>
        <ul class="inner-lead">
          <li><strong>Smart Boards:</strong> Equipped with interactive whiteboards that support touch-based and digital stylus input.</li>
          <li><strong>Audio-Visual Systems:</strong> Integrated sound systems and high-definition digital projectors in every smart room.</li>
          <li><strong>High-Speed IT:</strong> All classrooms are supported by robust internet connectivity for real-time digital resource access.</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Specialized Spaces</h4>
        <ul class="inner-lead">
          <li><strong>CDC Smart Room:</strong> The Career Development Centre (CDC) features a specialized smart room for professional workshops.</li>
          <li><strong>Multimedia Content:</strong> Teachers utilize digital presentations, educational videos, and interactive modules.</li>
          <li><strong>Hybrid Ready:</strong> Infrastructure supports both physical and virtual collaboration for seminars and guest lectures.</li>
        </ul>
      </div>
    </div>

    <!-- Interactive Folder / Gallery Sections -->
    <div class="gallery-section mt-5">
      <h3 class="gallery-title text-center mb-4">Explore Our Facility Folders</h3>
      
      <!-- Folders Navigation -->
      <div class="d-flex justify-content-center gap-3 mb-4">
        <button class="btn btn-folder" [class.active]="activeTab === 'classrooms'" (click)="setActiveTab('classrooms')">
          <i class="fas fa-folder-open me-2"></i> Academic Smart Classrooms
        </button>
        <button class="btn btn-folder" [class.active]="activeTab === 'cdc'" (click)="setActiveTab('cdc')">
          <i class="fas fa-folder-open me-2"></i> CDC Smart Seminar Rooms
        </button>
      </div>

      <!-- Classrooms Gallery Grid -->
      <div class="row g-3 justify-content-center" *ngIf="activeTab === 'classrooms'">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of classroomsImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Academic Smart Classroom" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View</span>
            </div>
          </div>
        </div>
      </div>

      <!-- CDC Gallery Grid -->
      <div class="row g-3 justify-content-center" *ngIf="activeTab === 'cdc'">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of cdcImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="CDC Smart Seminar Room" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Smart Classrooms View">
      </div>
    </div>

    <div class="mt-5 text-center">
       <p class="text-muted small"><em>Where technology meets tradition to inspire excellence.</em></p>
    </div>

  </div>
</div>

